<template>
  <sl-page>
    <div class='page-filter'>
      <Row :gutter="12">
        <Col span="6" :lg="6" :md="8" :sm="12" :xs="24" class="margin-bottom">
          <sl-select v-model="params.companyId" placeholder="所属企业" :disabled="!!id" :data="companies" :filterable="true" @on-change="handleCompanyChange"></sl-select>
        </Col>
        <Col span="6" :lg="6" :md="8" :sm="12" :xs="24" class="margin-bottom">
          <sl-select v-model="params.groupIds" placeholder="所属分组" :data="groups" :filterable="true"></sl-select>
        </Col>
        <Col span="6" :lg="6" :md="8" :sm="12" :xs="24" class="margin-bottom">
          <DatePicker v-model="params.daterange" type="daterange" placement="bottom-end" placeholder="时段" style="width: 100%"></DatePicker>
        </Col>
        <Col span="6" :lg="6" :md="8" :sm="12" :xs="24" class="page-action">
        <div>
          <Button type="primary" icon="ios-search" @click="query()">查询</Button>
          <Button icon="ios-reset" @click="reset()">重置</Button>
        </div>
        </Col>
      </Row>
    </div>
    <div class="cnt">
      <div class='hd'>
        <div>人员</div>
        <div>2019-05-01</div>
        <div>2019-05-02</div>
        <div>2019-05-03</div>
        <div>2019-05-04</div>
        <div>2019-05-05</div>
      </div>
      <div class="bd">
        <div class="item">
          <div>张三</div>
          <div>
            <p>小铁骑早高峰</p>
            <p>小铁骑日间平峰</p>
          </div>
          <div>
            <a @click="handleCreateShift">添加</a>
          </div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div class="item">
          <div>李四</div>
          <div>
          </div>
          <div>
            <p>大铁骑早高峰</p>
            <p>大铁骑日间平峰</p>
          </div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </sl-page>
</template>
<script>
import { phoneValidator, emptyValidator, idNumberValidator } from '@/util/validator'
import scheduleItem from './detail'
import global from '@/util/mixin/global'

export default {
  components:{scheduleItem},
  mixins:[global],
  data() {
    return {
      def: {},
      params:{
        companyId:null,
        groupIds:null,
        daterange:[]
      },
      id: null,
      loading: false,
      isCreate: true,
      groups: [],
      companies: [],
      modalVisible: false,
    }
  },

  created() {
    this.def = { ...this.form }

    this.$request.courierCompanies({ "search": {}, "pageSize": 1000, "pageNum": 1 }).then(resp => {
      if (!resp.code) {
        this.companies = resp.data.list.filter(i => i.id != this.id).map(i => ({
          value: i.id,
          label: i.companyName
        }))
      }
    })

  },

  methods: {

    init(id, type) {
      this.id = id
      this.reset()
      this.type = type
      this.modalVisible = true
      if (this.id) {
        this.query()
      }

      if (this.isCompany) {
        if (this.userinfo.companys) {
          this.form.companyId = this.userinfo.companys[0].id
          this.updateGroups()
        }
      }
    },

    query() {
      let params = { search: {...this.params}, pageSize: 999 }
      if (this.params.groupIds) {
        params.search.groupIds = [this.params.groupIds]
      }

      this.$request.couriers(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.flat(this.$utils.conv(resp.data.list || [], { 'createDatetime': 'datetime', 'status': '$enable', 'gender': '$gender', groupName , mileageDisplay , durationDisplay}))
          this.page.total = resp.data.total || 0
        }
      })
    },

    reset() {
      
    },

    save() {
      //
      let params = { ...this.form }

      if(this.area[0]) params.province = this.area[0]
      if(this.area[1]) params.city = this.area[1]
      if(this.area[2]) params.area = this.area[2]

      params.companyType = this.type
      params.groupIds = [this.form.groupIds]
      this.loading = true
      let promise = this.id ? this.$request.courierUpdate : this.$request.courierCreate
      promise(params).then(resp => {
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('保存成功')
          this.$emit('on-update')
          if (!this.id) {
            this.modalVisible = false
          }
        }
        this.loading = false
      })
    },

    updateGroups() {
      this.$request.courierGroupByCompanyId(this.params.companyId).then(resp => {
        if (!resp.code) {
          this.groups = (resp.data || []).map(i => ({
            value: i.id,
            label: i.groupName,
            disabled:i.status == 1
          }))
        }
      })
    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },

    handleCreateShift(){
      this.$slDialog.show({
        title:'添加排班',
        width:450,
        footerHide:true,

        render:(h)=>{
          return h(scheduleItem , {
            on:{
              close:(d)=>{
                console.log(d)
              }
            }
          })
        }
      })
    },
    handleClose() {
      this.$emit('on-update')
    },

    handleCompanyChange() {
      this.updateGroups()
    }
  }
}

</script>
<style lang='scss'>
  .cnt{
    .hd{
      display: table;
      border-top:1px solid rgba(0,0,0,.1);
      border-bottom:1px solid rgba(0,0,0,.1);

      &>div{
        width:150px;
        padding:25px 15px;
        display: inline-block;
        font-size: 14px;
        color:rgba(0,0,0,.65);
        vertical-align: middle;
        position:relative;
        &:before{
          content: '';
          position: absolute;
          left:0;top:0;
          width:1px;
          height: 100%;
          background-color:rgba(0,0,0,0.1)
        }

        &:last-child{
         border-right:1px solid rgba(0,0,0,.1);
        }
      }
      background: #f5f6f9;
    }

    .bd .item{
      border-bottom:1px solid rgba(0,0,0,.1);
      display: table;
      &>div{
        width:150px;
        padding:15px;
        font-size: 14px;
        line-height: 1.75em;
        color:rgba(0,0,0,.75);
        display: table-cell;
        position:relative;
        vertical-align: middle;
        &:before{
          content: '';
          position: absolute;
          left:0;top:0;
          width:1px;
          height: 100%;
          background-color:rgba(0,0,0,0.1)
        }

        &:last-child{
         border-right:1px solid rgba(0,0,0,.1);
        }
      }
    }
  }
</style>